<ng-container *ngFor="let info of nestedOutputInfosPlusMore">
  <div [hidden]="(info.isDisplayed$ | async) === false">
    <div class="label-grid">
      <div class="line"></div>
      <div
        class="label-text"
        [class.blank-required]="info.isRequiredAndBlank$ | async"
      >
        {{ info.label }}<ng-container *ngIf="info.required">*</ng-container>
        <ng-container *ngIf="info.isFused">(fused)</ng-container>
      </div>
      <div class="action-area">
        <div
          *ngIf="info.hasKeyframe$"
          class="keyframe-toggle-wrapper"
          [style.pointer-events]="info.keyframeTogglePointerEvents$ | async"
        >
          <a (click)="removeKeyframe(info.outputInfoStore)">
            <svg viewBox="0 0 100 100" class="keyframe-toggle">
              <polygon
                [class.is-keyframe]="info.hasKeyframe$ | async"
                points="50 0, 0 50, 50 100, 100 50"
              />
            </svg>
          </a>
        </div>
        <div
          *ngIf="shouldHideClearAnswerButton(info.outputInfoStore) === false"
          class="clear-button"
        >
          <a (click)="resetOutput(info.outputInfoStore)">
            <mat-icon class="material-symbols-outlined" matTooltip="Clear"
              >cancel</mat-icon
            >
          </a>
        </div>
      </div>
    </div>

    <h3-nestable-output
      [outputInfoStore]="info.outputInfoStore"
      [withinTagEditor]="true"
    ></h3-nestable-output>
  </div>
</ng-container>
